var React = require('react');

function TakeControlIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.557 18a8 8 0 0 0 8-8 8 8 0 1 0-16 0 8 8 0 0 0 8 8Z","style":{"fillOpacity":".3","fillRule":"nonzero"},"key":0}),React.createElement("path",{"d":"m13.992 8.597-.018 16.476 3.611-3.332 2.698 6.116 3.688-1.474-2.561-5.809 5.122-.002-12.54-11.975Z","style":{"fillRule":"nonzero"},"key":1})]);
}

TakeControlIcon.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = TakeControlIcon;

TakeControlIcon.default = TakeControlIcon;
